<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        Loading(:isLoading="isDataLoading", type="bar")
          template(v-if="currentEquity.cdsUnrealizedPnLDtos && currentEquity.cdsUnrealizedPnLDtos.length === 0")
            .pad_t--15
              MessageBar(type="warning")
                | No records found. You are currently not holding any equities.

          template(v-else)
            .current--container(v-for="account in currentEquityProcessed.cdsAccounts")
              .current--summary-cards
                .row
                  .col-lg-3
                    .card.current--summary-card: .card--body
                      .current--summary-card_title.text--color_grey
                        small CDS Account
                      .current--summary-card_info
                        span.current--summary-card_value {{ account.cdsNumber }}
                  .col-lg-3
                    .card.current--summary-card: .card--body
                      .current--summary-card_title.text--color_grey
                        small Total Market Value
                      .current--summary-card_info
                        span.current--summary-card_value {{ account.totalMarketValue | twoDecimal }}
                        span.current--summary-card_label MYR
                  .col-lg-3
                    .card.current--summary-card: .card--body
                      .current--summary-card_title.text--color_grey
                        small Investment Amount
                      .current--summary-card_info
                        span.current--summary-card_value {{ account.totalNetAmount | twoDecimal}}
                        span.current--summary-card_label MYR
                  .col-lg-3
                    .card.current--summary-card: .card--body
                      .current--summary-card_title.text--color_grey
                        small Unrealized P/L
                      .current--summary-card_info
                        span.current--summary-card_value(:class="account.performance") 
                          | {{ account.totalUnrealizedPnL | twoDecimal}} <span class="value_percent" v-if="account.totalUnrealizedPnlPct != null">({{ account.totalUnrealizedPnlPct | twoDecimal }}%)</span>

              .current--summary-table
                .card: .card--body
                  DataTable(:records="account.stocks", :headers="headers")
                    template(v-slot:slot-for-avgBuyingPrice="item")
                      | {{ (item.record.netAmount / item.record.netQuantity) | decimal}}

                    template(v-slot:slot-for-msRating="item")
                      a(:href="item.record.morningStarResearchUrl || ''", target="_blank")
                        template(v-for="index in item.record.morningStarRating")
                          Star

                    template(v-slot:slot-for-msFairValue="item")
                      template(v-if="item.record.morningStarFairValue")
                        | {{ item.record.morningStarFairValue | decimal }}
                        CircleDownloadPdf(:url="item.record.morningStarResearchUrl", variant="secondary", ml="8")

                  

          .pad_t--30.text--color_grey
            small Shareholdings are updated once a day, please refer TCPlus for latest shareholdings. The 'AVG. BUY PRICE" in the table above are estimated figure based only on historical purchase contracts from March 2015 onwards. They DO NOT take into account any corporation actions or share transfers.
          .pad_t--20.text--color_grey
            small
              strong SALIENT TERMS AND CONDITIONS FOR AFFIN HWANG CAPITAL EINVEST ('THE SERVICE')
              br
              | The Client (whether application is made for Basic or Full version of Affin Hwang Capital eInvest) hereby authorises the Company to disclose the stock balances to the Client for the purpose of viewing and facilitating the sale or purchase of securities transactions through Affin Hwang Capital eInvest by the Client. However, the stock balances shown may not reflect the current status, hence, it must not be regarded as a conclusive representative of the actual stock balances in the Client's CDS Account. The Client is strongly advised to verify the stock balances status with the Client's own records or the Dealer's Representative(s) or the Company to obtain confirmation on the accuracy on the stock balances in the Client's CDS account before placing any orders to sell. The Client agrees and further authorises the Company to disclose the stock balances to the Client's Dealer's Representative(s) for the purpose of facilitating the Client's sale or purchase of securities. The Client shall not hold the Company liable for any losses whatsoever in respect of such disclosure of the stock balances to the Client through Affin Hwang Capital eInvest, including but not limited to the use of or reliance on the stock balances information and execution of sale orders by the Client due to the inaccuracy of the stock balances provided via Affin Hwang Capital eInvest. 
</template>



<script>
import requestHandlers from '../../mixins/requestHandlers';

import allFilters from '../../lib/filters';

import DoughnutChart from '../../components/charts/Doughnut';
import DataTable from '../../components/DataTable';
import MessageBar from '../../components/MessageBar';
import CircleDownloadPdf from '../../components/CircleDownloadPdf';
import Loading from '../../components/Loading';
import Star from "../../components/Star";


export default {
  name: 'portfolioCurrent',
  
  mixins: [requestHandlers],

  components: {
    DoughnutChart,
    DataTable,
    Loading,
    Star,
    MessageBar,
    CircleDownloadPdf
  },

  data() {
    return {
      // Charts Related
      // -------------------------------
      chart_data: null,
      chart_options: {
        title: {
          display: true,
          text: 'Summary of Equity Holdings by Industry',
          fontSize: 16,
        },
        responsive: true,
        legend: {
          position: 'top',
          labels: {
            boxWidth: 18,
            fontSize: 18
          }
        }
      },
      currentEquity: {},
      headers: [
        {
          id: 'counter',
          text: 'Counter',
          sortable: true,
          type: 'counter',
          colWidth: 10,
        },
        {
          id: 'country',
          text: 'Country',
          type: 'string',
          colAlignment: 'center',
          colWidth: 8,
        },
        {
          id: 'netQuantity',
          text: 'Quantity',
          type: 'number',
          sortable: false,
          filter: 'round',
          colAlignment: 'center',
          colWidth: 12,
        },
        {
          id: 'avgBuyingPrice',
          text: 'Avg. Buy Price',
          type: 'custom_slot',
          colAlignment: 'center',
          colWidth: 12,
        },
        {
          id: 'currentPrice',
          text: 'Current Price',
          type: 'number',
          sortable: false,
          filter: 'decimal',
          colAlignment: 'center',
          colWidth: 12,
        },
        {
          id: 'marketValue',
          text: 'Market Value',
          type: 'number',
          sortable: false,
          filter: 'round',
          colAlignment: 'center',
          colWidth: 12,
        },
        {
          id: 'unrealizedPnL',
          text: 'Unrealised P/L',
          type: 'number',
          sortable: false,
          filter: 'round',
          colAlignment: 'center',
          colWidth: 14,
        },
        {
          id: 'msFairValue',
          text: 'Morningstar Fair Value',
          type: 'custom_slot',
          colAlignment: 'center',
          colWidth: 9,
        },
      ]
    }
  },

  computed: {
    currentEquityProcessed() {
      if(this.currentEquity.cdsUnrealizedPnLDtos && this.currentEquity.cdsUnrealizedPnLDtos.length) {
        let _obj = {
          cdsAccounts: [],
          overallNetAmount: this.currentEquity.overallNetAmount,
          overallMarketValue: this.currentEquity.overallMarketValue,
          overallUnrealizedPnL: this.currentEquity.overallUnrealizedPnL,
          summaryByIndustryItems: this.currentEquity.summaryByIndustryItems,
        }

        _obj.cdsAccounts = this.currentEquity.cdsUnrealizedPnLDtos.map(acc => {
          let _acc = {
            cdsNumber: acc.cdsNumber,
            totalNetAmount: acc.totalNetAmount,
            totalMarketValue: acc.totalMarketValue,
            totalUnrealizedPnL: acc.totalUnrealizedPnL,
            totalUnrealizedPnlPct: acc.totalUnrealizedPnlPct < 0 ? acc.totalUnrealizedPnlPct * -1 : acc.totalUnrealizedPnlPct,
            performance: '',
            stocks: [],
          }

          if(acc.totalUnrealizedPnL > 0) {
            _acc.performance = 'positive';
          } else if(acc.totalUnrealizedPnL === 0) {
            _acc.performance = 'neutral';
          } else {
            _acc.performance = 'negative';
          }

          _acc.stocks = acc.counters.data.map(stock => {
            let _stock = {
              country: stock.attributes.country,
              industry: stock.attributes.industry,
              netQuantity: stock.attributes.unrealizedPnlInfo.netQuantity,
              netAmount: stock.attributes.unrealizedPnlInfo.netAmount,
              currentPrice: stock.attributes.currentPrice,
              marketValue: stock.attributes.unrealizedPnlInfo.marketValue,
              unrealizedPnL: stock.attributes.unrealizedPnlInfo.unrealizedPnL,
              pnLPct: stock.attributes.unrealizedPnlInfo.pnLPct,
              morningStarResearchUrl: stock.attributes.morningStarResearchUrl,
              morningStarRating: 0,
              morningStarFairValue: '-',
              counterDto: {
                name: stock.attributes.name,
                code: stock.attributes.code,
              }
            }

            if(stock.attributes.morningStarRating.length) {
              _stock.morningStarRating = Number(stock.attributes.morningStarRating[0].QuantitativeStarRating);
              _stock.morningStarFairValue = stock.attributes.morningStarRating[0].QuantitativeFairValue;
            }

            return _stock;
          })

          return _acc;
        });

        return _obj;

      } else {
        return { };
      }
    }
  },

  methods: {
    FETCH_STOCK_HOLDING_RECORDS() {
      this.REQUEST_INIT();
      this.$axios.get('/Portfolio/PnL/Unrealized')
      .then(response => {
        if(response.status === 200) {

          // Set current equity from response data
          this.currentEquity = response.data.data;

          // Draw summary chart if data is provided
          let summaryByIndustry = this.currentEquityProcessed.summaryByIndustryItems;
          if(Array.isArray(summaryByIndustry) && summaryByIndustry.length) {
            this.DRAW_SUMMARY_CHART(this.currentEquityProcessed.summaryByIndustryItems);
          }

          // Fetch morning start report
          this.FETCH_MORNINGSTAR_RESERACH_URL(this.currentEquity);
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    },

    DRAW_SUMMARY_CHART(data) {
      let simpleColoursArray = ['#e6194b', '#3cb44b', '#ffe119', '#4363d8', '#f58231', '#911eb4', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075', '#808080', '#ffffff', '#000000'];

      let _obj = {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: []
        }],
      };

      data.forEach((item, i) => {
        _obj.labels.push(item.industryName);
        _obj.datasets[0].data.push(item.marketValue);
        _obj.datasets[0].backgroundColor.push(simpleColoursArray[i]);
      });

      this.chart_data = _obj;
    },

    FETCH_MORNINGSTAR_RESERACH_URL(currentEquity) {
      currentEquity.cdsUnrealizedPnLDtos.forEach((account, accountIndex) => {
        account.counters.data.forEach((stock, stockIndex) => {
          let { attributes: { code, morningStarResearchUrl } } = stock;

          if(morningStarResearchUrl == null) {
            this.$axios.get('/Counters/MorningstarResearchUrl?stockCode=' + code)
            .then(response => {
              if(response.status === 200) {
                stock.attributes.morningStarResearchUrl = response.data;
              }
            })
            .catch(error => this.DUMMY_RETURN_NOTHING(error))
          }
        })
      })
    },
  },

  filters: {
    decimal: allFilters.decimal,
    twoDecimal: allFilters.twoDecimal,
    round: allFilters.round,
  },

  created() {
    this.FETCH_STOCK_HOLDING_RECORDS();
  },
}

</script>




<style lang="scss">
  .current--container {
    + .current--container {
      padding-top: 80px;
    }
  }
  .current--summary-table {
    margin-top: 20px;

    @include MQ(MD) {
      margin-top: 0;
    }
  }
  .current--summary-cards {

  }
  .current--summary-card {
    border-radius: 10px;

    @include MQ(MD) {
      border-radius: 4px;
      margin-bottom: 10px;
    }

    .card--body {
      @include MQ(MD) {
        padding: 10px 15px;
      }
    }
  }
  .current--summary-card_title {
    text-transform: uppercase;
  }
  .current--summary-card_info {
    padding-top: 5px;
    span {
      font-weight: 500;
    }
  }
  .current--summary-card_label {
    letter-spacing: -1px;
    margin-left: 8px;
    opacity: 0.7;
  }
  .current--summary-card_value {
    @include primaryFont600;
    font-size: 150%;

    @include MQ(LG) {
      font-size: 140%;
    }
    @include MQ(MD) {
      font-size: 140%;
    }
    @include MQ(SM) {
      font-size: 130%;
    }
    @include MQ(XS) {
      font-size: 120%;
    }

    &.positive {
      color: $color-success;
    }
    &.negative {
      color: $color-error;
    }

    .value_percent {
      font-size: 80%;

      @include MQ(SM) {
        font-size: 90%;
      }
    }
  }
  
</style>
